const resendBqIntegration = async ({ url, data, api }) => {
  return await api(`bqIntegration/resend/${data.id}`, { body: data, method: 'POST' })
    .then((res) => {
      return Promise.resolve({ data: res });
    })
};

export default resendBqIntegration;